import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { useWsStatus, WsConnectionStatus } from '../../store/wsStatusStore';

const DOT_COLOR: Record<WsConnectionStatus, string> = {
  connected:    'success.main',
  connecting:   'warning.main',
  disconnected: 'error.main',
};

const LABEL: Record<WsConnectionStatus, string> = {
  connected:    'Connecté',
  connecting:   'Connexion…',
  disconnected: 'Déconnecté',
};

function WsStatusBadge() {
  const { status, error } = useWsStatus();

  const dot = (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        { process.env.REACT_APP_IS_DEV === 'true' &&
            <Typography variant="caption" sx={{ color: 'red', userSelect: 'none' }}>DEV</Typography>
        }

        <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          bgcolor: DOT_COLOR[status],
          flexShrink: 0,
          ...(status === 'connecting' && {
            animation: 'ws-pulse 1.4s ease-in-out infinite',
            '@keyframes ws-pulse': {
              '0%, 100%': { opacity: 1 },
              '50%':       { opacity: 0.3 },
            },
          }),
        }}
      />
      <Typography variant="caption" sx={{ color: 'text.secondary', userSelect: 'none' }}>
        {LABEL[status]}
      </Typography>
    </Box>
  );

  if (status === 'disconnected' && error) {
    return (
      <Tooltip title={error} placement="top" arrow>
        {dot}
      </Tooltip>
    );
  }

  return dot;
}

export default WsStatusBadge;
